import config from '../../config/config';
import { Button } from 'react-bootstrap';
import Fetch from '../../../core/util/core/Fetch';
import Toast from '../../../core/components/core/Util/Toast/Toast';
import { useState } from 'react';

function QueuesReset() {
    const [disabledButton, setDisabledButton] = useState(false);
    const [textButton, setButtonText] = useState('Resetar Filas');

    const resetQueues = async () => {
        setDisabledButton(true);
        setButtonText('Resetando...');

        const response = await Fetch.post(
            config.endpoints.backend + 'governanceroom/queues/reset'
        );

        setDisabledButton(false);
        setButtonText('Resetar Filas');

        if (response.status === 1) {
            Toast.success('Filas do RabbitMQ resetadas com sucesso!');
        } else {
            Toast.error('Ocorreu um erro ao resetar as filas do RabbitMQ.');
        }
    };

    return (
        <>
            <section className="content" style={{ marginTop: '30px' }}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card card-outline card-info">
                                <div className="card-header">
                                    <h3 className="card-title">
                                        <i className="fa-solid fa-rotate-right mr-1"></i>
                                        Resetar Filas
                                    </h3>
                                </div>
                                <div className="ml-3 mt-5 mb-5">
                                    <p>
                                        Esta tela possui a única função de
                                        limpar as mensagens pendentes nas
                                        filas do RabbitMQ e reiniciar os
                                        consumidores.
                                    </p>
                                    <Button
                                        style={{ width: 'auto' }}
                                        onClick={() => resetQueues()}
                                        disabled={disabledButton}
                                    >
                                        {textButton}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default QueuesReset;
